export const eventTrackerConstant = {
  CART_HOLD: 'CART_HOLD',
  ORDER_EDITED: 'ORDER_EDITED',
  ORDER_RECEIPT_REPRINT: 'ORDER_RECEIPT_REPRINT',
  CART_DELETED: 'CART_DELETED',
  LOYALTY_AWARDED: 'LOYALTY_AWARDED',
  CART_ITEM_REMOVED: 'CART_ITEM_REMOVED',
  PAYMENT_MODE_CHANGED: 'PAYMENT_MODE_CHANGE'
}